export const SSO_PROVIDERS = {
  GOOGLE: 'google',
  FACEBOOK: 'facebook',
  APPLE: 'apple',
};

export const RESPONSE_PROVIDERS = {
  BACKEND: 'backend',
  PROXY: 'proxy',
  ...SSO_PROVIDERS,
};
